export function normalizeTracked(value) {
    if (typeof value === 'object') {
        if (value === null || Array.isArray(value)) {
            return undefined;
        }
        const tracked = {};
        const obj = value;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        if (isOldTracked(obj)) {
            if (obj.current !== undefined) {
                tracked.current = { value: obj.current, time: obj.lastTime };
            }
            if (obj.first !== undefined) {
                tracked.first = { value: obj.first, time: obj.firstTime };
            }
            if (obj.last !== undefined) {
                tracked.last = { value: obj.last, time: obj.lastTime };
            }
        }
        else {
            tracked.current = obj.current;
            tracked.first = obj.first;
            tracked.last = obj.last;
            tracked.previous = obj.previous;
        }
        return tracked;
    }
    return undefined;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function isOldTracked(value) {
    return 'firstTime' in value || 'lastTime' in value;
}
//# sourceMappingURL=normalizeTracked.js.map